// @ts-ignore
import ROUTE from './route'
import DiversityHome from './containers/diversityHome';
import TokenSurvey from './components/TokenSurvey';
export default [
    {
        name: 'DiversityHome',
        path: ROUTE.diversityHome,
        component: DiversityHome,
        exact: true,
        protect: true
    },
    {
        name: 'TokenSurvey',
        path: ROUTE.tokenSurvey,
        component: TokenSurvey
    }
]